<template>
  <div id="app">
    <Header></Header>
    <keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from './components/Header'
import Foot from './components/Foot'
export default {
  name: 'app',
  mounted(){
    if(window.sessionStorage.getItem('currentMenu')){
      let num = parseInt(window.sessionStorage.getItem('currentMenu'))
      this.$store.commit({
        type: 'setState',
        num: num
      })
    }

  },
  components: {
    Header,
    Foot
  }
}
</script>

<style>
@import "assets/css/reset.css";
/*轮播 tabs*/
.el-carousel__indicators{
  text-align: left;
  width: 1100px;
  bottom: 326px!important;
}
.h_c_ref .el-carousel{
  padding-top: 100px;
  padding-bottom: 40px;
}
.h_c_ref .el-carousel__container{
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 6px 36px 0 rgba(0, 0, 0, 0.08);
}
.el-carousel__button{
  height: 4px!important;
}
.el-carousel__indicators .el-carousel__button{
  background-color: #fff!important;
}
.el-carousel__indicator.is-active .el-carousel__button{
  background-color: #00B76B!important;
}
/*首页轮播文字样式*/
.h_c_ref .h_c_r_p{
  padding: 34px 0;
}
.h_c_ref .h_c_r_p p{
  font-size: 16px;
  color: #808080;
  line-height: 25px;
  text-align: center;
}
/*加入我们扇形区域样式调整*/
.el-collapse .el-collapse-item{
  margin-bottom: 20px;
}
.el-collapse-item__header{
  height: 70px!important;
  background-color: #00B76B!important;
  color: #fff!important;
}
.el-collapse-item__wrap{
  border-bottom: none!important;
}
.el-collapse-item__content{
  background-color: #F4F7FA!important;
  font-size: 14px!important;
}
.con_clllapse .el-icon-arrow-right{
  width: 26px;
  height: 26px;
  margin-right: 20px!important;
  background: url("assets/images/icon-jiantou3.png") no-repeat center/26px;
}
.el-collapse-item__arrow.is-active{
  transform: rotate(180deg)!important;
}
.con_clllapse .el-icon-arrow-right::before{
  content: ''!important;
}
  /*法律法规tab*/
.el-tabs__nav{
  float: inherit!important;
}
.el-tabs__item{
  padding: 0!important;
  height: 68px!important;
  line-height: 68px!important;
  text-align: center;
  width: 50%!important;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  background-color: #00B76B!important;
  color: #fff!important;
  font-size: 16px!important;
  border-bottom-color: #00B76B!important;
}
/*管家服务里的样式*/
.sw_item_l_cent .sw_item_l_c_des .sw_item_l_c_ul p{
  line-height: 19px;
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}
/*信息公告 列表区域*/
.in_co_ul li .le_title .le_t_des p{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.in_co_ul li .le_title .le_t_des img{
  display: none;
}
  /*信息详情页面*/
.dea_content img{
  display: block;
  width: 800px;
  height: 400px;
  margin: 40px auto;
}
.dea_content p{
  font-size: 14px;
  line-height: 19px;
  color: #333;
  margin-bottom: 20px;
}
/*工程案例样式*/
.projectWindow .pro_right p{
  font-size: 16px;
  color: #999;
  line-height: 21px
}
</style>
